import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'primereact/button';
import { TabView, TabPanel } from 'primereact/tabview';
import { loadModulePerformanceHeatmapAsync, loadTestPerformanceHeatmapAsync, currentYearRange } from '../dashboardSlice';
import { ModulePerformanceHeatmap } from '../components/ModulePerformanceHeatmap';
import { TestPerformanceHeatmap } from '../components/TestPerformanceHeatmap';

// Cada aba só busca seus dados na primeira vez que é selecionada — mesmo
// padrão do DashboardView.js. Sem "ano letivo" no domínio, o default é o ano
// calendário corrente — o botão de refresh do topo reseta pra esse default
// (descarta o período escolhido no Calendar, se houver). Único ponto de
// reload da página — os cards (ModulePerformanceHeatmap/TestPerformanceHeatmap,
// showReload={false}) não têm mais botão próprio, pra não duplicar.
const TAB_LOADERS = [
    (dispatch) => dispatch(loadModulePerformanceHeatmapAsync({ ...currentYearRange(), activeOnly: true })),
    (dispatch) => dispatch(loadTestPerformanceHeatmapAsync({ ...currentYearRange(), activeOnly: true })),
];

const HeatmapPerformancePage = () => {
    const dispatch = useDispatch();
    const [activeIndex, setActiveIndex] = useState(0);
    const loadedTabs = useRef(new Set());

    const loadTab = useCallback((index) => {
        loadedTabs.current.add(index);
        TAB_LOADERS[index]?.(dispatch);
    }, [dispatch]);

    useEffect(() => {
        loadTab(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Recarrega só a aba ativa (ignora o cache de "já carreguei antes").
    const onRefresh = () => loadTab(activeIndex);

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <div className="flex justify-content-between align-items-center mb-3">
                        <h5 className="m-0">Heatmap de desempenho</h5>
                        <Button
                            icon="pi pi-refresh"
                            rounded
                            text
                            onClick={onRefresh}
                        />
                    </div>
                    <TabView
                        activeIndex={activeIndex}
                        onTabChange={(e) => {
                            setActiveIndex(e.index);
                            if (!loadedTabs.current.has(e.index)) loadTab(e.index);
                        }}
                    >
                        <TabPanel header="Módulo">
                            <ModulePerformanceHeatmap showReload={false} />
                        </TabPanel>
                        <TabPanel header="Prova">
                            <TestPerformanceHeatmap showReload={false} />
                        </TabPanel>
                    </TabView>
                </div>
            </div>
        </div>
    );
};

export default HeatmapPerformancePage;
